var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.20833 7.54491V5.00645C3.20833 3.25401 4.64475 1.83337 6.41667 1.83337C8.18858 1.83337 9.625 3.25401 9.625 5.00645L9.625 8.49684C9.625 9.37306 8.90679 10.0834 8.02083 10.0834C7.13488 10.0834 6.41667 9.37306 6.41667 8.49684L6.41667 5.00645",
    stroke: "#2177FE",
    strokeWidth: 1.375,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4583 1.83337H11.7083C14.6978 1.83337 16.1925 1.83337 17.2305 2.56472C17.5279 2.77427 17.7919 3.02277 18.0146 3.30269C18.7916 4.27966 18.7916 5.68645 18.7916 8.50004V10.8334C18.7916 13.5496 18.7916 14.9077 18.3618 15.9924C17.6707 17.7362 16.2093 19.1117 14.3565 19.7621C13.204 20.1667 11.761 20.1667 8.87498 20.1667C7.22583 20.1667 6.40126 20.1667 5.74269 19.9355C4.68396 19.5639 3.84883 18.7779 3.45395 17.7814C3.20831 17.1616 3.20831 16.3855 3.20831 14.8334V11",
    stroke: "#2177FE",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7917 11C18.7917 12.6875 17.4236 14.0556 15.7361 14.0556C15.1258 14.0556 14.4063 13.9486 13.8129 14.1076C13.2857 14.2489 12.8739 14.6607 12.7326 15.1879C12.5736 15.7813 12.6806 16.5008 12.6806 17.1111C12.6806 18.7986 11.3125 20.1667 9.625 20.1667",
    stroke: "#2177FE",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileAttachment);
export default __webpack_public_path__ + "static/media/file-attachment.e793575ddbc91eea604cccc2d1be6a26.svg";
export { ForwardRef as ReactComponent };